import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AdminsPage from './pages/admins/AdminsPage';
import LeadsPage from './pages/crm/LeadsPage';
import LeadDetailPage from './pages/crm/LeadDetailPage';
import StatusesPage from './pages/crm/StatusesPage';
import ChatsPage from './pages/whatsapp/ChatsPage';
import TemplatesPage from './pages/whatsapp/TemplatesPage';
import BotPage from './pages/whatsapp/BotPage';
import CallsPage from './pages/crm/CallsPage';
import DevicesPage from './pages/crm/DevicesPage';
import CustomFieldsPage from './pages/crm/CustomFieldsPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route
              path="/admins"
              element={
                <ProtectedRoute permission="admins.view">
                  <AdminsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/leads"
              element={
                <ProtectedRoute permission="crm.leads.view">
                  <LeadsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/leads/:id"
              element={
                <ProtectedRoute permission="crm.leads.view">
                  <LeadDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/calls"
              element={
                <ProtectedRoute anyPermission={['crm.calls.view_all', 'crm.calls.view_own']}>
                  <CallsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/devices"
              element={
                <ProtectedRoute permission="crm.devices.manage">
                  <DevicesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/statuses"
              element={
                <ProtectedRoute permission="crm.statuses.manage">
                  <StatusesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/custom-fields"
              element={
                <ProtectedRoute permission="crm.custom-fields.manage">
                  <CustomFieldsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/whatsapp/chats"
              element={
                <ProtectedRoute anyPermission={['whatsapp.chats.view_all', 'whatsapp.chats.view_own', 'whatsapp.chats.initiate']}>
                  <ChatsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/whatsapp/templates"
              element={
                <ProtectedRoute permission="whatsapp.templates.manage">
                  <TemplatesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/whatsapp/bot"
              element={
                <ProtectedRoute permission="whatsapp.bot.configure">
                  <BotPage />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
